import { request, queryString } from '../../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/clients/funding-period'

export default {
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  updateFunder (id, values) {
    return request(`${url}/${id}/funder`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  listDetailsByPage (page, size, filter, sorting, text) {
    return request(`${url}/list/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getDefaultRateSet (catgeoryId, startDate, endDate) {
    return request(`${url}/rate-set/${catgeoryId}/${startDate}/${endDate}`)
  }
}
